<template>
  <div class="bankCardBox">
    <div class="main">
      <p>请绑定持卡人本人的银行卡</p>
      <div class="bankCard" v-if="bankinfo">
        <div class="card">
          <h5>{{ bankinfo.bankname }}</h5>
          <div class="cardNumber">{{ bankinfo.accountno }}</div>
        </div>
        <div class="li">
          <p>持卡人</p>
          <span>{{ bankinfo.customerName }}</span>
        </div>
        <div class="btn" @click="unbindBankCard()">解除绑定</div>
      </div>
      <div class="addBankCard" v-else @click="addBankCard()">
        <img src="@/assets/img/h5/add_g.png" alt />
        <p>添加银行卡</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "我的银行卡",
    };
  },
  name: "bankCard",
  data() {
    return {
      bankinfo: "", //我的银行卡信息
      customerbankid: "",
    };
  },

  mounted() {
    this.getBankCard();
  },
  beforeRouteEnter(to, from, next) {
    next((vw) => {
      if (from.path == "/h5/mine/bankCard/verify") {
        window.location.reload();
        // this.$router.go(0);
      }
    });
  },

  methods: {
    getBankCard() {
      this.$post(
        "/iart-api-crm/api/crm/customerbankdetails/queryBankCard",
        {}
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            this.bankinfo = res.data;
            this.customerbankid = res.data.customerbankid;
          } else {
            // this.util.toast({ msg: res.data.rtnmsg });//未绑定银行卡时,会报“银行卡信息不存在”
          }
        }
      });
    },

    unbindBankCard() {
      var obj = {
        customerbankid: this.customerbankid,
      };
      this.$post(
        "/iart-api-crm/api/crm/customerbankdetails/unbindBankCard",
        obj
      ).then((res) => {
        if (res.code == 1) {
          //  this.$router.go(0); //解决iOS刷新失效
          window.location.reload();
          this.util.toast({ msg: "解绑成功" });
        } else {
          this.util.toast({ msg: res.data.rtnmsg });
        }
      });
    },

    addBankCard() {
      var obj = {
        this: this,
        loginStatus: false,
        url: "/h5/mine/bankCard/bindBankCard",
      };
      this.util.goto(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.bankCardBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f4f4f7;
  padding: 16px;
  .main {
    flex: 1;
    overflow: auto;
    background: #f4f4f7;
    p {
      color: rgba(53, 54, 60, 0.4);
      font-size: 12px;
      line-height: 22px;
    }
    .bankCard {
      .card {
        width: 343px;
        height: 138px;
        background: url(../../../../assets/img/h5/bankModal.png), no-repeat;
        background-size: 100%;
        margin: 16px 0 24px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: left;
        padding: 40px 34px;
        h5 {
          color: rgba(255, 255, 255, 0.6);
          font-size: 16px;
          line-height: 22px;
          margin-bottom: 8px;
        }
        .cardNumber {
          color: #ffffff;
          font-size: 22px;
          line-height: 28px;
        }
      }
      .li {
        display: flex;
        flex-direction: row;
        justify-content: center;
        justify-content: space-between;
        align-items: center;
        color: #35363c;
        line-height: 20px;
        padding: 16px 0 16px;
        p {
          color: #35363c;
          font-size: 14px;
          font-weight: bold;
        }
        span {
          font-size: 14px;
          font-weight: 400;
        }
      }
      .btn {
        width: 100%;
        padding: 14px 34px;
        // background: #FFFFFF;
        border-radius: 3px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        margin-top: 40px;
        border: 1px solid #3a444e;
      }
    }
    .addBankCard {
      width: 100%;
      height: 138px;
      background: #ffffff;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
      border-radius: 8px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        font-size: 16px;
        line-height: 22px;
        color: rgba(53, 54, 60, 0.4);
        margin-left: 4px;
      }
    }
  }
}
</style>